module.exports = __webpack_public_path__ + "images/psp/hero/mini-storage-hero.webp";